export default __webpack_public_path__ + "static/media/element_27.530daaa3.webp";